import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { client } from '../../api/client';

const initialState = {
  assets: [],
  status: 'idle',
  error: null,
  showModal: false,
  curAsset: {
    asset: {
      index: 0,
      params: {
        name: '',
        'unit-name': '',
        url: '',
        decimals: 0,
        creator: '',
        total: 0,
        clawback: '',
      },
    },
    assetItem: {
      id: '',
      sender: '',
      assetIndex: 0,
      amount: 0,
      receiver: '',
    },
    refetch: {},
  },
};

export const fetchAssetsById = createAsyncThunk('assets/fetchAssetbyId', async (assetId) => {
  const response = await client.get(
    `https://mainnet-idx.algonode.cloud/v2/assets/${assetId}`
    // `https://algoindexer.testnet.algoexplorerapi.io/v2/assets/${assetId}`
  );

  return response.data;
});

export const fetchAssetsByAccount = createAsyncThunk(
  'assets/fetchAssetsByAccount',
  async (acct) => {
    const assetArr = acct.assets.map((asset) => asset['asset-id']);
    const assetObj = assetArr.map((asset) => ({ ...asset, 'asset-id': asset }));
    return assetObj;
  }
);

const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    addAsset: (state, action) => {
      state.assets.push(action.payload);
    },
    showModal: (state, action) => {
      state.showModal = action.payload;
    },
    setCurAsset: (state, action) => {
      state.curAsset = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAssetsById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAssetsById.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.assets.push(action.payload);
        state.assets = state.assets.concat(action.payload);
      });
  },
});

export const { addAsset, showModal, setCurAsset } = assetsSlice.actions;

export default assetsSlice.reducer;

// export const { selectAll: selectAllAssets } = assetsAdapter.getSelectors((state) => state);

export const selectAllAssets = (state) => state.assets.assets;

export const selectAssetById = (state, assetId) => {
  state.assets.assets.filter((asset) => asset.index === assetId);
};

// export const selectAssetById = (state, assetId) => {
//   console.log('State in selector by id', state);
//   return state.find((asset) => asset['asset-id'] === assetId);
// };

// {
//   accounts: {
//     accounts: [
//       {
//         address: '7GCKZQTKD2GC7HK6LNUQ3M7C7QQOGPQJYI6QXTWHQOPKYLE3KSO2DEUJKE',
//         amount: 100447010,
//         'amount-without-pending-rewards': 100447010,
//         assets: [
//           {
//             amount: 0,
//             'asset-id': 19386116,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17167906,
//             'opted-out-at-round': 17189027
//           },
//           {
//             amount: 0,
//             'asset-id': 21582981,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17168016
//           },
//           {
//             amount: 0,
//             'asset-id': 33054790,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17147693
//           },
//           {
//             amount: 0,
//             'asset-id': 33060123,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17147939
//           },
//           {
//             amount: 0,
//             'asset-id': 19386452,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17168935
//           },
//           {
//             amount: 0,
//             'asset-id': 15322902,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17169007,
//             'opted-out-at-round': 17189024
//           }
//         ],
//         'created-assets': [
//           {
//             'created-at-round': 17147939,
//             deleted: false,
//             index: 33060123,
//             params: {
//               clawback: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//               creator: '7GCKZQTKD2GC7HK6LNUQ3M7C7QQOGPQJYI6QXTWHQOPKYLE3KSO2DEUJKE',
//               decimals: 0,
//               'default-frozen': false,
//               freeze: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//               manager: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//               name: 'Energy',
//               'name-b64': 'RW5lcmd5',
//               reserve: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//               total: 1000,
//               'unit-name': 'NRG',
//               'unit-name-b64': 'TlJH',
//               url: 'https://path/to/my/asset/details',
//               'url-b64': 'aHR0cHM6Ly9wYXRoL3RvL215L2Fzc2V0L2RldGFpbHM='
//             }
//           },
//           {
//             'created-at-round': 17147693,
//             deleted: false,
//             index: 33054790,
//             params: {
//               clawback: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//               creator: '7GCKZQTKD2GC7HK6LNUQ3M7C7QQOGPQJYI6QXTWHQOPKYLE3KSO2DEUJKE',
//               decimals: 0,
//               'default-frozen': false,
//               freeze: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//               manager: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//               name: 'Energy',
//               'name-b64': 'RW5lcmd5',
//               reserve: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//               total: 1000,
//               'unit-name': 'NRG',
//               'unit-name-b64': 'TlJH',
//               url: 'https://path/to/my/asset/details',
//               'url-b64': 'aHR0cHM6Ly9wYXRoL3RvL215L2Fzc2V0L2RldGFpbHM='
//             }
//           }
//         ],
//         'created-at-round': 17147391,
//         deleted: false,
//         'pending-rewards': 0,
//         'reward-base': 27521,
//         rewards: 0,
//         round: 18969384,
//         'sig-type': 'sig',
//         status: 'Offline'
//       },
//       {
//         address: 'GMANGPUDJOB63LWVHCU2N3DJ656SZEDNKZ7SPWWZQEG5GHVCW6QVOXDPYI',
//         amount: 1541123928,
//         'amount-without-pending-rewards': 1541123928,
//         'apps-local-state': [
//           {
//             deleted: false,
//             id: 21580889,
//             'opted-in-at-round': 16152888,
//             schema: {
//               'num-byte-slice': 0,
//               'num-uint': 16
//             }
//           },
//           {
//             deleted: false,
//             id: 29777539,
//             'opted-in-at-round': 17025993,
//             schema: {
//               'num-byte-slice': 0,
//               'num-uint': 0
//             }
//           },
//           {
//             deleted: false,
//             id: 37156208,
//             'opted-in-at-round': 17250921,
//             schema: {
//               'num-byte-slice': 0,
//               'num-uint': 0
//             }
//           }
//         ],
//         'apps-total-schema': {
//           'num-byte-slice': 0,
//           'num-uint': 16
//         },
//         assets: [
//           {
//             amount: 446069,
//             'asset-id': 19386116,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 16516555,
//             'opted-out-at-round': 17188507
//           },
//           {
//             amount: 18443,
//             'asset-id': 21582981,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 16152904,
//             'opted-out-at-round': 17189316
//           },
//           {
//             amount: 1107839,
//             'asset-id': 15322902,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17042623,
//             'opted-out-at-round': 17188505
//           },
//           {
//             amount: 0,
//             'asset-id': 37153549,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17250738
//           },
//           {
//             amount: 970,
//             'asset-id': 33054790,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17184334,
//             'opted-out-at-round': 17189300
//           },
//           {
//             amount: 960,
//             'asset-id': 33060123,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 17151482,
//             'opted-out-at-round': 17189238
//           },
//           {
//             amount: 2741048,
//             'asset-id': 19386452,
//             creator: '',
//             deleted: false,
//             'is-frozen': false,
//             'opted-in-at-round': 16516580,
//             'opted-out-at-round': 17188509
//           }
//         ],
//         'created-assets': [
//           {
//             'created-at-round': 17250738,
//             deleted: false,
//             index: 37153549,
//             params: {
//               creator: 'GMANGPUDJOB63LWVHCU2N3DJ656SZEDNKZ7SPWWZQEG5GHVCW6QVOXDPYI',
//               decimals: 0,
//               'default-frozen': false,
//               manager: 'GMANGPUDJOB63LWVHCU2N3DJ656SZEDNKZ7SPWWZQEG5GHVCW6QVOXDPYI',
//               name: 'Tiny Magician',
//               'name-b64': 'VGlueSBNYWdpY2lhbg==',
//               reserve: 'GMANGPUDJOB63LWVHCU2N3DJ656SZEDNKZ7SPWWZQEG5GHVCW6QVOXDPYI',
//               total: 1,
//               'unit-name': 'M7S',
//               'unit-name-b64': 'TTdT',
//               url: 'https://gateway.pinata.cloud/ipfs/QmWvpQPLg48bcCvaZNFmZEP85x8dbAtNMi2eM6deCozBXQ',
//               'url-b64': 'aHR0cHM6Ly9nYXRld2F5LnBpbmF0YS5jbG91ZC9pcGZzL1FtV3ZwUVBMZzQ4YmNDdmFaTkZtWkVQODV4OGRiQXROTWkyZU02ZGVDb3pCWFE='
//             }
//           }
//         ],
//         'created-at-round': 16152879,
//         deleted: false,
//         'pending-rewards': 0,
//         'reward-base': 27521,
//         rewards: 0,
//         round: 18969384,
//         'sig-type': 'sig',
//         status: 'Offline'
//       }
//     ],
//     status: 'succeeded',
//     error: null
//   },
//   assets: {
//     assets: [
//       {
//         asset: {
//           'created-at-round': 15389471,
//           deleted: false,
//           index: 19386116,
//           params: {
//             clawback: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             creator: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             decimals: 8,
//             'default-frozen': false,
//             freeze: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             manager: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             'metadata-hash': 'ZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2U=',
//             name: 'Bitcoin >< Algorand',
//             'name-b64': 'Qml0Y29pbiA+PCBBbGdvcmFuZA==',
//             reserve: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             total: 2100000000000000,
//             'unit-name': 'goBTC',
//             'unit-name-b64': 'Z29CVEM='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 15821041,
//           deleted: false,
//           index: 21582981,
//           params: {
//             clawback: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             creator: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             decimals: 5,
//             'default-frozen': false,
//             freeze: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             manager: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             name: 'Tiny Gold',
//             'name-b64': 'VGlueSBHb2xk',
//             reserve: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             total: 18446744073709552000,
//             'unit-name': 'TINYAU',
//             'unit-name-b64': 'VElOWUFV',
//             url: 'https://tinyman.org',
//             'url-b64': 'aHR0cHM6Ly90aW55bWFuLm9yZw=='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 17147939,
//           deleted: false,
//           index: 33060123,
//           params: {
//             clawback: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             creator: '7GCKZQTKD2GC7HK6LNUQ3M7C7QQOGPQJYI6QXTWHQOPKYLE3KSO2DEUJKE',
//             decimals: 0,
//             'default-frozen': false,
//             freeze: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             manager: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             name: 'Energy',
//             'name-b64': 'RW5lcmd5',
//             reserve: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             total: 1000,
//             'unit-name': 'NRG',
//             'unit-name-b64': 'TlJH',
//             url: 'https://path/to/my/asset/details',
//             'url-b64': 'aHR0cHM6Ly9wYXRoL3RvL215L2Fzc2V0L2RldGFpbHM='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 17147693,
//           deleted: false,
//           index: 33054790,
//           params: {
//             clawback: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             creator: '7GCKZQTKD2GC7HK6LNUQ3M7C7QQOGPQJYI6QXTWHQOPKYLE3KSO2DEUJKE',
//             decimals: 0,
//             'default-frozen': false,
//             freeze: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             manager: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             name: 'Energy',
//             'name-b64': 'RW5lcmd5',
//             reserve: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             total: 1000,
//             'unit-name': 'NRG',
//             'unit-name-b64': 'TlJH',
//             url: 'https://path/to/my/asset/details',
//             'url-b64': 'aHR0cHM6Ly9wYXRoL3RvL215L2Fzc2V0L2RldGFpbHM='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 13596306,
//           deleted: false,
//           index: 15322902,
//           params: {
//             clawback: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             creator: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             decimals: 6,
//             'default-frozen': false,
//             freeze: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             manager: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             name: 'Lamps',
//             'name-b64': 'TGFtcHM=',
//             reserve: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             total: 100000000000,
//             'unit-name': 'LAMP',
//             'unit-name-b64': 'TEFNUA=='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 17147693,
//           deleted: false,
//           index: 33054790,
//           params: {
//             clawback: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             creator: '7GCKZQTKD2GC7HK6LNUQ3M7C7QQOGPQJYI6QXTWHQOPKYLE3KSO2DEUJKE',
//             decimals: 0,
//             'default-frozen': false,
//             freeze: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             manager: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             name: 'Energy',
//             'name-b64': 'RW5lcmd5',
//             reserve: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             total: 1000,
//             'unit-name': 'NRG',
//             'unit-name-b64': 'TlJH',
//             url: 'https://path/to/my/asset/details',
//             'url-b64': 'aHR0cHM6Ly9wYXRoL3RvL215L2Fzc2V0L2RldGFpbHM='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 15821041,
//           deleted: false,
//           index: 21582981,
//           params: {
//             clawback: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             creator: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             decimals: 5,
//             'default-frozen': false,
//             freeze: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             manager: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             name: 'Tiny Gold',
//             'name-b64': 'VGlueSBHb2xk',
//             reserve: 'B4XVZ226UPFEIQBPIY6H454YA4B7HYXGEM7UDQR2RJP66HVLOARZTUTS6Q',
//             total: 18446744073709552000,
//             'unit-name': 'TINYAU',
//             'unit-name-b64': 'VElOWUFV',
//             url: 'https://tinyman.org',
//             'url-b64': 'aHR0cHM6Ly90aW55bWFuLm9yZw=='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 17250738,
//           deleted: false,
//           index: 37153549,
//           params: {
//             clawback: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY5HFKQ',
//             creator: 'GMANGPUDJOB63LWVHCU2N3DJ656SZEDNKZ7SPWWZQEG5GHVCW6QVOXDPYI',
//             decimals: 0,
//             'default-frozen': false,
//             freeze: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY5HFKQ',
//             manager: 'GMANGPUDJOB63LWVHCU2N3DJ656SZEDNKZ7SPWWZQEG5GHVCW6QVOXDPYI',
//             name: 'Tiny Magician',
//             'name-b64': 'VGlueSBNYWdpY2lhbg==',
//             reserve: 'GMANGPUDJOB63LWVHCU2N3DJ656SZEDNKZ7SPWWZQEG5GHVCW6QVOXDPYI',
//             total: 1,
//             'unit-name': 'M7S',
//             'unit-name-b64': 'TTdT',
//             url: 'https://gateway.pinata.cloud/ipfs/QmWvpQPLg48bcCvaZNFmZEP85x8dbAtNMi2eM6deCozBXQ',
//             'url-b64': 'aHR0cHM6Ly9nYXRld2F5LnBpbmF0YS5jbG91ZC9pcGZzL1FtV3ZwUVBMZzQ4YmNDdmFaTkZtWkVQODV4OGRiQXROTWkyZU02ZGVDb3pCWFE='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 15389545,
//           deleted: false,
//           index: 19386452,
//           params: {
//             clawback: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             creator: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             decimals: 8,
//             'default-frozen': false,
//             freeze: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             manager: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             'metadata-hash': 'ZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2U=',
//             name: 'Ether >< Algorand',
//             'name-b64': 'RXRoZXIgPjwgQWxnb3JhbmQ=',
//             reserve: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             total: 15000000000000000,
//             'unit-name': 'goETH',
//             'unit-name-b64': 'Z29FVEg='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 15389471,
//           deleted: false,
//           index: 19386116,
//           params: {
//             clawback: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             creator: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             decimals: 8,
//             'default-frozen': false,
//             freeze: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             manager: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             'metadata-hash': 'ZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2U=',
//             name: 'Bitcoin >< Algorand',
//             'name-b64': 'Qml0Y29pbiA+PCBBbGdvcmFuZA==',
//             reserve: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             total: 2100000000000000,
//             'unit-name': 'goBTC',
//             'unit-name-b64': 'Z29CVEM='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 17147939,
//           deleted: false,
//           index: 33060123,
//           params: {
//             clawback: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             creator: '7GCKZQTKD2GC7HK6LNUQ3M7C7QQOGPQJYI6QXTWHQOPKYLE3KSO2DEUJKE',
//             decimals: 0,
//             'default-frozen': false,
//             freeze: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             manager: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             name: 'Energy',
//             'name-b64': 'RW5lcmd5',
//             reserve: 'YSJBWOXNKEN62IIBJX2TPGJQO53ZBO57ZRUQ4BRANOXOU6ZUC256BVTRL4',
//             total: 1000,
//             'unit-name': 'NRG',
//             'unit-name-b64': 'TlJH',
//             url: 'https://path/to/my/asset/details',
//             'url-b64': 'aHR0cHM6Ly9wYXRoL3RvL215L2Fzc2V0L2RldGFpbHM='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 13596306,
//           deleted: false,
//           index: 15322902,
//           params: {
//             clawback: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             creator: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             decimals: 6,
//             'default-frozen': false,
//             freeze: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             manager: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             name: 'Lamps',
//             'name-b64': 'TGFtcHM=',
//             reserve: 'PBSSJ2W6FDXVRPT4L4FGHTX2IHY3VREI44SB7VJTVT75UT6ER3CTVD6B74',
//             total: 100000000000,
//             'unit-name': 'LAMP',
//             'unit-name-b64': 'TEFNUA=='
//           }
//         },
//         'current-round': 18969392
//       },
//       {
//         asset: {
//           'created-at-round': 15389545,
//           deleted: false,
//           index: 19386452,
//           params: {
//             clawback: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             creator: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             decimals: 8,
//             'default-frozen': false,
//             freeze: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             manager: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             'metadata-hash': 'ZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2U=',
//             name: 'Ether >< Algorand',
//             'name-b64': 'RXRoZXIgPjwgQWxnb3JhbmQ=',
//             reserve: 'QLMCWNC37TKTZSWOOWV36BLCUBVMAQ45YVOPVNX7IOC5NPSAO76OEYUCZY',
//             total: 15000000000000000,
//             'unit-name': 'goETH',
//             'unit-name-b64': 'Z29FVEg='
//           }
//         },
//         'current-round': 18969392
//       }
//     ],
//     status: 'succeeded',
//     error: null
//   }
